export enum ETheme{
    ICON_MOON = 'fa-solid fa-moon fa-spin fa-flip-horizontal fa-2xl',
    ICON_SUN = 'fa-solid fa-sun fa-spin fa-2xl'
}
